import { Injectable, ElementRef } from '@angular/core';


@Injectable({
	providedIn: 'root'
})
export class LegalNavbarService {

	//** Element holder */
	navbarElement!: ElementRef;

	//** Set navBar elementRef */
	setNavbarElement(element: ElementRef): void {
		this.navbarElement = element;
	}

	//** Get navBar elementRef */
	getNavbarElement(): ElementRef {
		return this.navbarElement;
	}
}
